module.exports = __webpack_public_path__ + "static/instagram-adb6689fdadd7f5d39fe02ab2674fef2.png";